import { Component, OnInit } from '@angular/core';
import { SecurityService } from 'src/app/system/security.service';

@Component({
  selector: 'app-admin-layouts',
  templateUrl: './admin-layouts.component.html',
  styleUrls: ['./admin-layouts.component.scss']
})
export class AdminLayoutsComponent implements OnInit {

  public IsAuthorized: any;
  public dropdown : boolean;

  constructor(
    private securityService: SecurityService
  ) {
    this.IsAuthorized = securityService.IsAuthorized;
    this.dropdown = false;
  }

  ngOnInit(): void {
  }

  showDropdown(): void{
    this.dropdown = !this.dropdown;
  }
}
